<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <tt-button-goto *ngIf="setting.amount_topay_rest !== '0' || setting.prepayments_add_new_always === '1'" ttText="prepayments_create_new" ttGoto="prepayment" [ttGotoParms]="{ argtype: argType, argvalue: argValue, prepayment_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>

        <tt-list [ttData]="itemsListPrepayments"></tt-list>

        <tt-card *ngIf="setting.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-3 p-5">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <div class="col-xs-12 col-md-3 p-5">
            <tt-list [ttData]="itemsListPrepayments"></tt-list>

            <tt-card *ngIf="setting.show_setting === '1'">
                <tt-button-settings></tt-button-settings>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-3 p-5" *ngIf="setting.amount_topay_rest !== '0' || setting.prepayments_add_new_always === '1'">
            <tt-button-goto ttText="prepayments_create_new" ttGoto="prepayment" [ttGotoParms]="{ argtype: argType, argvalue: argValue, prepayment_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!setting">
        <tt-input ttLabel="businessco_companyname" [ttModel]="setting.businessco_companyname" ttReadonly></tt-input>
        <tt-input-number ttLabel="amount_total_topay" [ttModel]="setting.amount_total_topay" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="amount_paid_before" [ttModel]="setting.amount_paid_before" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="amount_topay_rest" [ttModel]="setting.amount_topay_rest" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
    </ng-container>
</ng-template>
